import script from "./BudgetDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetDetails.vue?vue&type=script&setup=true&lang=js"

import "./BudgetDetails.vue?vue&type=style&index=0&id=07c83bb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c83bb4"]])

export default __exports__